/* eslint-disable no-console */

import { register } from 'register-service-worker'

const options: any = {
    ready() {
        console.log(
            'App is being served from cache by a service worker.\n' +
            'For more details, visit https://goo.gl/AFskqB'
        )
    },
    registered() {
        console.log('Service worker has been registered.')
    },
    cached() {
        console.log('Content has been cached for offline use.')
    },
    updatefound() {
        console.log('New content is downloading.')
    },
    updated(registration: any) {
        console.log('New content is available; automatically applying update...')

        // Automatically apply the update without user interaction
        let worker = registration.waiting
        if (worker) {
            // Listen for when the new service worker takes control
            navigator.serviceWorker.addEventListener('controllerchange', () => {
                console.log('New service worker activated, reloading page...')
                window.location.reload()
            })

            // Tell the waiting service worker to skip waiting and become active
            worker.postMessage({ 
                action: 'skipWaiting' 
            })
        }
    },
    offline() {
        console.log('No internet connection found. App is running in offline mode.')
    },
    error(error: any) {
        console.error('Error during service worker registration:', error)
    }
}

if (process.env.NODE_ENV === 'production') {
    register(`${ process.env.BASE_URL }service-worker.js`, options)
}